import { ShortcutRounded as ForwardIcon } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import * as dates from "common/dates";
import * as strings from "common/strings";
import Component from "components/Component";
import Comment from "components/comments/Comment";
import { useSelector } from "react-redux";
import * as submissionsService from "services/submissionsService";
import * as persistenceSelectors from "store/selectors/persistence/persistenceSelectors";

const AllocationCard = ({ allocation }) => (
  <>
    <Comment
      comment={{
        userId: allocation?.senderEmail,
        initials: strings.extractNameFromEmail(allocation?.senderEmail)
          .initials,
        label: allocation?.senderEmail,
        time: dates.readableDate(allocation?.createTime, { includeTime: true }),
        content: allocation?.comments,
      }}
    />
    <Stack
      direction={"row"}
      alignItems={"center"}
      sx={{ margin: "-0.5rem 0 0 3.25rem !important" }}
      gap={0.5}
    >
      <ForwardIcon
        fontSize={"small"}
        sx={{ transform: "scaleY(-1)" }}
        color={"secondary"}
      />
      <Typography variant={"subtitle2"}>
        {allocation?.recipientEmail}
      </Typography>
    </Stack>
  </>
);

const Allocations = () => {
  const submissionId = useSelector(persistenceSelectors.selectSubmissionId);

  const {
    data: allocations,
    isLoading: isAllocationLoading,
  } = submissionsService.useListAllocationsQuery(
    { submissionId: submissionId },
    { skip: !submissionId }
  );

  const sortedAllocations = [...(allocations ?? [])].sort((a, b) =>
    (b?.createTime ?? "_").localeCompare(a?.createTime ?? "_")
  );

  return (
    <Component title={"Allocations"} isFetching={isAllocationLoading}>
      <Stack direction={"column"} alignItems={"start"} spacing={2}>
        {sortedAllocations.map((allocation) => (
          <AllocationCard key={allocation.id} allocation={allocation} />
        ))}
      </Stack>
    </Component>
  );
};

export default Allocations;
